module.exports = __webpack_public_path__ + "static/media/atividade-coletiva-observacao-cidadao.24334df0.webp";